import { render } from "./companies.vue?vue&type=template&id=a6343220&scoped=true"
import script from "./companies.vue?vue&type=script&lang=js"
export * from "./companies.vue?vue&type=script&lang=js"

import "./companies.vue?vue&type=style&index=0&id=a6343220&scoped=true&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6343220"]])

export default __exports__